import { render, staticRenderFns } from "./BeneficioFidelidade.vue?vue&type=template&id=7fdf58c9&scoped=true"
import script from "./BeneficioFidelidade.vue?vue&type=script&lang=js"
export * from "./BeneficioFidelidade.vue?vue&type=script&lang=js"
import style0 from "./BeneficioFidelidade.vue?vue&type=style&index=0&id=7fdf58c9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../corporativo/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fdf58c9",
  null
  
)

export default component.exports